<div>

  <navigation (onMenuButtonClick)="snav.toggle()"></navigation>

  <mat-sidenav-container [hasBackdrop]="isMobile()">

    <mat-sidenav #snav [mode]="isMobile() ? 'over' : 'side'"
      [fixedInViewport]="isMobile()"
      [opened]="!isMobile()"
      class="sidenav">
      <mat-nav-list>

        @if (isAuthenticated()) {
          <mat-list-item>
            <mat-icon
              (click)="navigate('/items-to-sell')"
              matListItemIcon
            fontSet="material-symbols-outlined">format_list_bulleted</mat-icon>
            <a matListItemTitle
              (click)="navigate('/items-to-sell')"
              angulartics2On="click"
              angularticsAction="Link Pressed"
              angularticsCategory="My items"
              angularticsLabel="My items"
            i18n>My items</a>
          </mat-list-item>
        }

        <mat-list-item>
          <mat-icon
            (click)="navigate('/marketplace')"
            matListItemIcon
          fontSet="material-symbols-outlined">storefront</mat-icon>

          <a matListItemTitle
            (click)="navigate('/marketplace')"
            angulartics2On="click"
            angularticsAction="Link Pressed"
            angularticsCategory="Marketplace"
            angularticsLabel="Marketplace"
          i18n>Marketplace</a>
        </mat-list-item>
        
        <mat-list-item>
          <mat-icon
            (click)="navigate('/')"
            matListItemIcon
          fontSet="material-symbols-outlined">photo_camera</mat-icon>

          <a matListItemTitle
            (click)="navigate('/')"
            angulartics2On="click"
            angularticsAction="Link Pressed"
            angularticsCategory="Snap&Sell"
            angularticsLabel="Snap&Sell"
          i18n>Snap&Sell</a>
        </mat-list-item>

      </mat-nav-list>
      <ng-template [cdkPortalOutlet]="sidenavService.pageSpecificNavigationPortals | async" (attached)="onPageSpecificNavigationPortalsAttached($event)"></ng-template>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>

  </mat-sidenav-container>
  <instant-bottom-sheet [isDialogOpen]="showConsent()">
    <instant-consent (onAccept)="closeConsentDialog()" (onDeny)="closeConsentDialog()"></instant-consent>
  </instant-bottom-sheet>
  @defer (hydrate on viewport) {
    <footer></footer>
  }
</div>